/**
 * 外部アプリから後から差し込まれる要素を検出する方法
 * MutationObserverを使用してDOMの変更を監視し、要素が追加されたときに検出する
 * 
 * Yotpoレビューボタンをクリックしたときに、リスト要素のdata-product-handle属性から
 * 商品ハンドルを取得して商品ページに遷移する
 */
(function() {
  'use strict';

  // 検出したい要素のセレクタ
  const TARGET_SELECTOR = '.yotpo-sr-bottom-line-button';
  
  // 既に処理済みの要素を追跡するためのSet
  const processedElements = new WeakSet();

  /**
   * リスト要素のdata-product-handle属性から商品ページURLを構築する
   * @param {HTMLElement} yotpoButton - Yotpoレビューボタン要素
   * @returns {string|null} 商品ページURL、見つからない場合はnull
   */
  function getProductUrlFromHandle(yotpoButton) {
    // 親の<li>要素を探す
    const listItem = yotpoButton.closest('li');
    
    if (!listItem) {
      console.warn('親の<li>要素が見つかりません');
      return null;
    }

    // data-product-handle属性を取得
    const productHandle = listItem.getAttribute('data-product-handle');
    
    if (!productHandle) {
      console.warn('data-product-handle属性が見つかりません');
      return null;
    }

    // 商品ページURLを構築（Shopifyの標準形式: /products/{handle}#yotpo-app）
    const productUrl = '/products/' + productHandle + '#yotpo-app';
    
    return productUrl;
  }

  /**
   * 商品ページに遷移する
   * @param {string} url - 遷移先のURL
   */
  function navigateToProductPage(url) {
    if (url) {
      window.location.href = url;
    } else {
      console.warn('有効な商品URLが見つかりません');
    }
  }

  /**
   * 要素が見つかったときに実行する処理
   */
  function handleElementFound(element) {
    // 既に処理済みの場合はスキップ
    if (processedElements.has(element)) {
      return;
    }

    // 処理済みとしてマーク
    processedElements.add(element);

    // イベントリスナーを追加
    element.addEventListener('click', function(e) {
      // デフォルトの動作を防ぐ（Yotpoのモーダルが開くのを防ぐ）
      e.preventDefault();
      e.stopPropagation();
      
      // リスト要素のdata-product-handle属性から商品ページURLを取得
      const productUrl = getProductUrlFromHandle(element);
      
      if (productUrl) {
        // 商品ページに遷移
        navigateToProductPage(productUrl);
      } else {
        console.warn('商品ハンドルが見つかりません');
      }
    });
  }

  /**
   * MutationObserverのコールバック関数
   */
  function mutationCallback(mutations, observer) {
    mutations.forEach(function(mutation) {
      // 追加されたノードをチェック
      mutation.addedNodes.forEach(function(node) {
        // 要素ノードでない場合はスキップ
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return;
        }

        // 追加されたノード自体が対象要素かチェック
        if (node.matches && node.matches(TARGET_SELECTOR)) {
          handleElementFound(node);
        }

        // 追加されたノードの子孫要素をチェック
        const foundElements = node.querySelectorAll ? node.querySelectorAll(TARGET_SELECTOR) : [];
        foundElements.forEach(function(element) {
          handleElementFound(element);
        });
      });
    });
  }

  /**
   * 初期化処理
   */
  function init() {
    // 既に存在する要素をチェック
    const existingElements = document.querySelectorAll(TARGET_SELECTOR);
    existingElements.forEach(function(element) {
      handleElementFound(element);
    });

    // MutationObserverを作成してDOMの変更を監視
    const observer = new MutationObserver(mutationCallback);

    // 監視設定: 子要素の追加・削除を監視し、サブツリー全体を監視
    const config = {
      childList: true,    // 子要素の追加・削除を監視
      subtree: true       // サブツリー全体を監視
    };

    // document.bodyを監視開始
    if (document.body) {
      observer.observe(document.body, config);
    } else {
      // bodyがまだ存在しない場合は、DOMContentLoadedを待つ
      document.addEventListener('DOMContentLoaded', function() {
        observer.observe(document.body, config);
      });
    }

    // タイムアウト設定（オプション）: 10秒後に監視を停止
    setTimeout(function() {
      observer.disconnect();
    }, 10000);
  }

  // ページ読み込み時に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // 既に読み込み済みの場合は即座に実行
    init();
  }
})();
